import React from "react";

function ActiveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M5.5 11C6.95869 11 8.35764 10.4205 9.38909 9.38909C10.4205 8.35764 11 6.95869 11 5.5C11 4.04131 10.4205 2.64236 9.38909 1.61091C8.35764 0.579463 6.95869 0 5.5 0C4.04131 0 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 0 4.04131 0 5.5C0 6.95869 0.579463 8.35764 1.61091 9.38909C2.64236 10.4205 4.04131 11 5.5 11ZM7.92773 4.49023L5.17773 7.24023C4.97578 7.44219 4.64922 7.44219 4.44941 7.24023L3.07441 5.86523C2.87246 5.66328 2.87246 5.33672 3.07441 5.13691C3.27637 4.93711 3.60293 4.93496 3.80273 5.13691L4.8125 6.14668L7.19727 3.75977C7.39922 3.55781 7.72578 3.55781 7.92559 3.75977C8.12539 3.96172 8.12754 4.28828 7.92559 4.48809L7.92773 4.49023Z"
        fill="#2563EB"
      />
    </svg>
  );
}

export default ActiveIcon;
